import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const ReceivablesByCategoryChart = (props) => {
  const history = useHistory();
  const { dataLabels, numbersChart, options } = props;

  const data = {
    labels: dataLabels,
    datasets: [
      {
        data: numbersChart,
        backgroundColor: [
          '#FF708B',
          '#c3c3c3',
          '#FFBA6A',
          '#7517FB',
          '#01E4D7',
        ],
        hoverBackgroundColor: [
          '#FF708B',
          '#c3c3c3',
          '#FFBA6A',
          '#7517FB',
          '#01E4D7',
        ],
        borderColor: 'rgba(255,255,255,0.54)',
      },
    ],
  };

  const legendOptions = {
    display: true,
    position: 'bottom',
    onClick: () => {},
  };

  const onChartClickHandler = () => {
    history.push('/minime/responsavel');
  };

  return (
    <Doughnut
      onElementsClick={() => onChartClickHandler()}
      height={300}
      data={data}
      legend={legendOptions}
      options={options}
    />
  );
};

ReceivablesByCategoryChart.propTypes = {
  dataLabels: PropTypes.arrayOf(PropTypes.shape),
  numbersChart: PropTypes.arrayOf(PropTypes.shape).isRequired,
  options: PropTypes.shape(PropTypes.shape),
};

ReceivablesByCategoryChart.defaultProps = {
  dataLabels: [],
  options: {},
};

export default withTranslation('common')(ReceivablesByCategoryChart);
